module.exports = __webpack_public_path__ + "img/hacker.26e496b8.png";